module.exports = __webpack_public_path__ + "images/153_1024.jpg";